import { render, staticRenderFns } from "./wtMakeNewStoryboard.component.vue?vue&type=template&id=8fbf36b2&scoped=true&"
import script from "./wtMakeNewStoryboard.component.vue?vue&type=script&lang=js&"
export * from "./wtMakeNewStoryboard.component.vue?vue&type=script&lang=js&"
import style0 from "./wtMakeNewStoryboard.component.vue?vue&type=style&index=0&id=8fbf36b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbf36b2",
  null
  
)

export default component.exports